export default __webpack_public_path__ + "static/eon.url-35aa020e4ae8492f291bcf9d9c1eb7a2.svg";